"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipeStatus = void 0;
const RecipeStatus = exports.RecipeStatus = {
  STATUS_DISABLE: false,
  STATUS_ENABLE: true
};